import { FC } from 'react';

interface Props {
  option: string;
  action: () => void;
  icon: React.ReactElement;
  currentYear: number;
}

const MultiStageSearchMonthOption: FC<Props> = ({
  option,
  icon,
  action,
  currentYear,
}) => {
  const handleButtonClick = () => {
    action();
  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const isMonthDisabled = () => {
    const monthIndex = monthNames.indexOf(option);
    return (
      currentYear === currentDate.getFullYear() && monthIndex + 1 < currentMonth
    );
  };

  return (
    <button
      className={`flex w-1 h-[4.8rem] mt-3 p-4 flex-col items-center gap-2 flex-1 rounded-2xl border ${
        isMonthDisabled()
          ? 'border-neutral-50 text-neutral-50'
          : 'border-neutral-100 text-black'
      }`}
      type="button"
      onClick={handleButtonClick}
      disabled={isMonthDisabled()}
    >
      <div>{icon}</div>
      <div>{option}</div>
    </button>
  );
};

export default MultiStageSearchMonthOption;
